/*************************************************************************
 *
 * c20g CONFIDENTIAL
 * __________________
 *
 *  [2007] - [2019] Counterpoint Consulting, Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Counterpoint Consulting Incorporated.
 * The intellectual and technical concepts contained
 * herein are proprietary to Counterpoint Consulting Incorporated
 * and its suppliers and may be covered by U.S. and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Counterpoint Consulting Incorporated.
 */
var Backbone = require('backbone');
var Marionette = require('backbone.marionette');
var Syphon = require('backbone.syphon');

var tmplSecComplianceRegistrationFormView = require('../templates/SecCompRegFormView.hbs');
var AddressView = require('common/views/AddressView');

module.exports = Marionette.LayoutView.extend({
  template: tmplSecComplianceRegistrationFormView,

  className: 'sec-compliance-registration-form-view',

  ui: {
    addressContainer: '.address-container'
  },

  regions: {
    addressContainer: '@ui.addressContainer'
  },

  behaviors: {
    PhoneFormatBehavior: {}
  },

  onBeforeShow: function() {
    var address = new Backbone.Model(this.model.get('userComplianceRegistration'));

    this.showChildView(
      'addressContainer',
      new AddressView({
        model: address,
        horizontal: false,
        startingCountry: address.get('country'),
        startingPostalCode: address.get('postalCode'),
        startingCounty: address.get('county'),
        isRequired: true
      })
    );
    Syphon.deserialize(this, this.model.get('userComplianceRegistration'));
  },

  getFormData: function() {
    var formData = Syphon.serialize(this);

    return formData;
  }
});
